import {fetchDelete, fetchGet, fetchPatch, fetchPost, postFormMultiMediaData} from "./util";

export const getBookkeepers = (results, columns, pageIndex, query, sort) => {
    return fetchGet(`/bookkeepers?results=${results}&columns=${columns}&offset=${pageIndex + 1}${query}${sort}`).then(res => res);
}

export const createBookkeeper = (data) => {
    return fetchPost(`/bookkeepers`, data).then(res => res);
}

export const deleteBookkeeper = (bookkeeperId) => {
    return fetchDelete(`/bookkeepers/${bookkeeperId}`).then(res => res);
}

export const updateBookkeeper = (bookkeeperId, data) => {
    return fetchPatch(`/bookkeepers/${bookkeeperId}`, data).then(res => res);
}

export const getBookkeeperByCvr = (cvrNumber) => {
    return fetchGet(`/bookkeeper/${cvrNumber}`).then(res => res);
}

export const bulkImportBookkeepers = (file) => {
    const form = new FormData();
    form.append("file", file);
    return postFormMultiMediaData(`/bookkeepers/import/csv`, form);
};

export const getBookkeeperImportHistory = async () => {
    return fetchGet('/bookkeepers/imports/history');
};